import React from 'react'
import Login from '../pages/Login'
import NotFound from '../pages/notFound'
import { Register } from '../pages/Register'
import { Verify } from '../pages/Verify'
import { Maintenance } from '../pages/Maintenance'
import { routes as routesForAdmin } from '../../admin/routers/router'
import { routes as routesForAnalysis } from '../../analysis/routers/router'

// Note: '/register','/verify'はProductIAMから直接遷移してくるページとして使用
export const routes = (t) => [
    ...routesForAdmin(t),
    ...routesForAnalysis(t),
    {
        path: '/loginiam',
        component: Login
    },
    {
        path: '/register',
        component: Register
    },
    {
        path: '/verify',
        component: Verify
    },
    {
        path: '/userRegistration',
        component: React.lazy(() => import('../pages/UserRegistration')),
        onlyGuest: true
    },
    {
        path: '/maintenance',
        component: Maintenance
    },
    {
        path: '/404',
        component: NotFound
    },
    {
        path: '/v2/chooseCmp',
        component: React.lazy(() => import('../pages/chooseCmp')),
        needToken: true
    },
    {
        path: '/v2/searchTheme',
        component: React.lazy(() => import('../pages/SearchTheme')),
        needToken: true
    },
    {
        path: '/v2/404',
        component: React.lazy(() => import('../pages/notFound'))
    },
    {
        path: '/v2/themePage',
        component: React.lazy(() => import('../pages/ThemePage')),
        needToken: true
    },
    {
        path: '/v2/companyDetail',
        component: React.lazy(() => import('../pages/CompantDetail')),
        needToken: true
    },
    {
        path: '/v2/newPage',
        component: React.lazy(() => import('../pages/newPages'))
    },
    {
        path: '/v2/TechnologyPortfolio',
        component: React.lazy(() => import('../pages/TechnologyPortfolio')),
        needToken: true
    },
    {
        path: '/v2/CountryTechnologyPortfolio',
        component: React.lazy(() => import('../pages/CountryTechnologyPortfolio')),
        needToken: true
    },
    {
        path: '/v2/support/about-the-service',
        component: React.lazy(() => import('../pages/support/AboutTheService')),
        name: t('supportHeader.aboutTheService'),
        needToken: true,
        isSupportRoute: true
    },
    {
        path: '/v2/support/how-to-use',
        component: React.lazy(() => import('../pages/support/HowToUse')),
        name: t('supportHeader.howToUse'),
        needToken: true,
        isSupportRoute: true
    },
    {
        path: '/v2/support/glossary',
        component: React.lazy(() => import('../pages/support/Glossary')),
        name: t('supportHeader.glossary'),
        needToken: true,
        isSupportRoute: true
    }
]
